export default "__VITE_ASSET__CXT5uSGI__"